import { AdminAbility } from '@repo/sdk/backoffice-abilities'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { pageTitle } from '@/lib/page-title'
import { requireAdminPermission } from '@/modules/permissions/lib/require-admin-permission'

export const Route = createFileRoute('/(private)/email-texts')({
	head: ({ match }) => ({
		meta: [
			{
				title: pageTitle(
					match.context.appLanguage,
					'admin-email-texts:page_title'
				)
			}
		]
	}),
	beforeLoad: requireAdminPermission([AdminAbility.EmailTextsManage]),
	staticData: { breadcrumb: 'admin-email-texts:page_title' },
	component: () => <Outlet />
})
